import { Routes } from '@angular/router';

export const routes: Routes = [
  // {path: '', redirectTo: 'home', pathMatch: 'full'},
  {path: '', loadComponent: () => import('./layout/home/home.component').then(m => m.HomeComponent)},
  {path: 'login', loadComponent: () => import('./login/login.component').then(m => m.LoginComponent)},
  {path: 'error', loadComponent: () => import('./layout/maintenance/maintenance.component').then(m => m.MaintenanceComponent)},
  {path: 'login-error', loadComponent: () => import('./layout/login-error/login-error.component').then(m => m.LoginErrorComponent)},
];
